import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputField from "components/fields/InputField";
import { VendorSelfReg } from "store/features/auth/authActions";
import {
  selectVendorRegSelfLoading,
  selectVendorRegSelfError,
} from "store/features/auth/authSelectors";
import { showSuccessToast } from "utils/toastNotification";

const VendorSelfRegister = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectVendorRegSelfLoading);
  const error = useSelector(selectVendorRegSelfError);

  const initialData = {
    name: "",
    email: "",
    phone: "",
    password: "",
    businessName: "",
    contactEmail: "",
    contactPhone: "",
  };

  const [formData, setFormData] = useState(initialData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(VendorSelfReg(formData));
    setFormData(initialData);
    showSuccessToast("Vendor registration successful");
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h1 className="mb-6 text-center text-2xl font-bold text-navy-700 dark:text-white">
          Vendor Registration
        </h1>

        {/* Display error message if any */}
        {error && (
          <div className="mb-4 rounded-md bg-red-100 p-3 text-red-700">
            {error.message || "Registration failed. Please try again."}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Personal Information Section */}
          <div className="space-y-3">
            <h2 className="text-lg font-semibold text-navy-700 dark:text-white">
              Personal Information
            </h2>

            <InputField
              label="Full Name"
              id="name"
              name="name"
              type="text"
              placeholder="Enter your full name"
              variant="auth"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <InputField
              label="Email"
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              variant="auth"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <InputField
              label="Phone"
              id="phone"
              name="phone"
              type="tel"
              placeholder="Enter your phone number"
              variant="auth"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <InputField
              label="Password"
              id="password"
              name="password"
              type="password"
              placeholder="Create a password"
              variant="auth"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          {/* Business Information Section */}
          <div className="space-y-3">
            <h2 className="text-lg font-semibold text-navy-700 dark:text-white">
              Business Information
            </h2>

            <InputField
              label="Business Name"
              id="businessName"
              name="businessName"
              type="text"
              placeholder="Enter your business name"
              variant="auth"
              value={formData.businessName}
              onChange={handleChange}
              required
            />

            <InputField
              label="Contact Email"
              id="contactEmail"
              name="contactEmail"
              type="email"
              placeholder="Enter business contact email"
              variant="auth"
              value={formData.contactEmail}
              onChange={handleChange}
              required
            />

            <InputField
              label="Contact Phone"
              id="contactPhone"
              name="contactPhone"
              type="tel"
              placeholder="Enter business contact phone"
              variant="auth"
              value={formData.contactPhone}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`mt-6 w-full rounded-xl bg-brand-500 py-3 text-sm font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ${
              isLoading ? "cursor-not-allowed opacity-70" : ""
            }`}
          >
            {isLoading ? "Registering..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VendorSelfRegister;
